var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarbonCloudApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7793 21.7234C42.0474 17.9417 40.0228 14.5325 37.0527 12.08C34.0825 9.62747 30.3518 8.28449 26.5 8.28125V11.5938C29.5814 11.5979 32.5656 12.6728 34.9419 14.6346C37.3182 16.5963 38.9388 19.3229 39.5264 22.3478L39.9554 24.5771L42.1897 24.9829C44.4269 25.3878 46.432 26.6145 47.8112 28.4221C49.1904 30.2297 49.844 32.4875 49.6438 34.7523C49.4436 37.0171 48.404 39.1253 46.7291 40.6628C45.0542 42.2004 42.865 43.0563 40.5914 43.0625H26.5V46.375H40.5914C43.692 46.3682 46.6782 45.2024 48.9632 43.1065C51.2482 41.0106 52.667 38.136 52.9409 35.0475C53.2148 31.9589 52.3241 28.8795 50.4435 26.4142C48.563 23.9489 45.8287 22.2757 42.7776 21.7234H42.7793Z",
    fill: "url(#paint0_linear_4405_6199)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 39.75H23.1875V43.0625H13.25V39.75Z",
    fill: "url(#paint1_linear_4405_6199)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 39.75H9.9375V43.0625H6.625V39.75Z",
    fill: "url(#paint2_linear_4405_6199)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 33.125H23.1875V36.4375H9.9375V33.125Z",
    fill: "url(#paint3_linear_4405_6199)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 33.125H6.625V36.4375H3.3125V33.125Z",
    fill: "url(#paint4_linear_4405_6199)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 26.5H23.1875V29.8125H13.25V26.5Z",
    fill: "url(#paint5_linear_4405_6199)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 26.5H9.9375V29.8125H6.625V26.5Z",
    fill: "url(#paint6_linear_4405_6199)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 19.875H23.1875V23.1875H16.5625V19.875Z",
    fill: "url(#paint7_linear_4405_6199)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 19.875H13.25V23.1875H9.9375V19.875Z",
    fill: "url(#paint8_linear_4405_6199)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 13.25H23.1875V16.5625H19.875V13.25Z",
    fill: "url(#paint9_linear_4405_6199)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4405_6199",
    x1: 39.7448,
    y1: 8.28125,
    x2: 39.7448,
    y2: 46.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4405_6199",
    x1: 18.2188,
    y1: 39.75,
    x2: 18.2188,
    y2: 43.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4405_6199",
    x1: 8.28125,
    y1: 39.75,
    x2: 8.28125,
    y2: 43.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4405_6199",
    x1: 16.5625,
    y1: 33.125,
    x2: 16.5625,
    y2: 36.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4405_6199",
    x1: 4.96875,
    y1: 33.125,
    x2: 4.96875,
    y2: 36.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4405_6199",
    x1: 18.2188,
    y1: 26.5,
    x2: 18.2188,
    y2: 29.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4405_6199",
    x1: 8.28125,
    y1: 26.5,
    x2: 8.28125,
    y2: 29.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4405_6199",
    x1: 19.875,
    y1: 19.875,
    x2: 19.875,
    y2: 23.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4405_6199",
    x1: 11.5938,
    y1: 19.875,
    x2: 11.5938,
    y2: 23.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4405_6199",
    x1: 21.5312,
    y1: 13.25,
    x2: 21.5312,
    y2: 16.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CBB70",
    stopOpacity: 0.41
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCloudApp);
export default __webpack_public_path__ + "static/media/carbon_cloud-app.b920ddba710a2ded340d914aaadcd46e.svg";
export { ForwardRef as ReactComponent };